import type {
  EntityAccessInvitation, EntityAccessInvitationResponse,
} from './entityAccess.invitations.repository';
import type {
  EntityAccess, EntityAccessResponse, NewEntityAccess,
} from './entityAccess.repository';

export const newEntityAccessesToApiParams = (
  newEntityAccess: ReadonlyArray<NewEntityAccess>,
) => (
  newEntityAccess.map(entityAccess => ({
    entity_type: entityAccess.entityType,
    shared_entity_type: entityAccess.sharedEntityType,
    access_level: entityAccess.accessLevel,
    entity_id: entityAccess.entityId,
    shared_entity_id: entityAccess.sharedEntityId,
  }))
);

export const entityAccessResponseToEntityAccess = (entityAccessResponse: EntityAccessResponse): EntityAccess => ({
  id: entityAccessResponse.id,
  ownerId: entityAccessResponse.owner_id,
  entityType: entityAccessResponse.entity_type,
  entityId: entityAccessResponse.entity_id,
  sharedEntityType: entityAccessResponse.shared_entity_type,
  sharedEntityId: entityAccessResponse.shared_entity_id,
  accessLevel: entityAccessResponse.access_level,
  createdAt: entityAccessResponse.created_at,
  updatedAt: entityAccessResponse.updated_at,
});

export const entityAccessInvitationResponseToEntityAccessInvitation = (response: EntityAccessInvitationResponse): EntityAccessInvitation => ({
  id: response.id,
  ownerId: response.owner_id,
  entityType: response.entity_type,
  entityId: response.entity_id,
  entityName: response.entity_name,
  sharedEntityType: response.shared_entity_type,
  sharedEntityId: response.shared_entity_id,
  accessLevel: response.access_level,
  createdAt: response.created_at,
  updatedAt: response.updated_at,
  createdBy: {
    id: response.created_by.id,
    name: response.created_by.name,
  },
});
